import React, { useCallback, useContext } from "react";
import { useHistory } from "react-router";
import { Formik } from "formik";
import * as Yup from "yup";
import firebase from "../../firebase";
import FIREBASE from "firebase";
import { SnackbarAlert } from "../SnackbarAlert";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
//import Divider from "@material-ui/core/Divider";
//import Facebook from "@material-ui/icons/Facebook";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
  buttonLogin: {
    textTransform: "none",
    color: theme.palette.common.white,
    padding: 13,
    borderRadius: 8,
    fontSize: "1.2em",
    letterSpacing: 1,
  },

  buttonFacebook: {
    textTransform: "none",
    color: theme.palette.common.white,
    padding: 13,
    borderRadius: 0,
    fontSize: "1.1em",
    letterSpacing: 0.7,
  },

  input: {
    margin: 5,
  },
}));

const LoginForm = () => {
  const classes = useStyles();
  const history = useHistory();
  const { setSnackbarState } = useContext(SnackbarAlert);
  const SESSION = FIREBASE.auth.Auth.Persistence.SESSION;
  const LOCAL = FIREBASE.auth.Auth.Persistence.LOCAL;

  ///*
  const verifyUserWithNumber = firebase
    .functions()
    .httpsCallable("verifyUserWithNumber");
  //*/

  const mobileRegEx = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  Yup.addMethod(Yup.string, "userID", function (customMessage) {
    const { ErrorMessage } = customMessage;
    return this.test("test-name", ErrorMessage, function (value) {
      const { path, createError } = this;
      const isMobileNumber = mobileRegEx.test(value);
      const isEmail = emailRegEx.test(value);
      return (
        isMobileNumber ||
        isEmail ||
        createError({ path, message: ErrorMessage })
      );
    });
  });

  return (
    <Formik
      initialValues={{
        userID: localStorage.getItem("userID"),
        password: localStorage.getItem("userPassword"),
        loginCheckbox:
          localStorage.getItem("rememberUser") === true ? true : false,
      }}
      validationSchema={Yup.object().shape({
        userID: Yup.string()
          .userID("Invalid format")
          .required("Please input your email/mobile number"),
        password: Yup.string().required("Please input your password"),
        loginCheckbox: Yup.boolean(),
      })}
      onSubmit={useCallback(
        async (values, actions) => {
          ///*
          try {
            if (mobileRegEx.test(values.userID)) {
              const handleUserID = await verifyUserWithNumber({
                userID: values.userID,
              });
              values.loginCheckbox === true
                ? await firebase.auth().setPersistence(LOCAL)
                : await firebase.auth().setPersistence(SESSION);
              await firebase
                .auth()
                .signInWithEmailAndPassword(handleUserID.data, values.password);

              if (values.loginCheckbox === true) {
                localStorage.setItem("userID", values.userID);
                localStorage.setItem("userPassword", values.password);
                localStorage.setItem("rememberUser", values.loginCheckbox);
              } else {
                localStorage.setItem("userID", "");
                localStorage.setItem("userPassword", "");
                localStorage.setItem("rememberUser", false);
              }
            } else {
              values.loginCheckbox === true
                ? await firebase.auth().setPersistence(LOCAL)
                : await firebase.auth().setPersistence(SESSION);
              await firebase
                .auth()
                .signInWithEmailAndPassword(values.userID, values.password);

              if (values.loginCheckbox === true) {
                localStorage.setItem("userID", values.userID);
                localStorage.setItem("userPassword", values.password);
                localStorage.setItem("rememberUser", values.loginCheckbox);
              } else {
                localStorage.setItem("userID", "");
                localStorage.setItem("userPassword", "");
                localStorage.setItem("rememberUser", false);
              }
            }
            setSnackbarState({
              state: true,
              message: "Login successful! Redirecting...",
              status: "info",
            });
            setTimeout(() => {
              history.push("/");
            }, 1800);
          } catch (error) {
            actions.resetForm();
            //console.log(error.code);
            //console.log(error.message);
            if (error.code === "auth/user-not-found") {
              setSnackbarState({
                state: true,
                message: "User ID or Password is incorrect. 😟",
                status: "error",
              });
            } else if (error.code === "auth/wrong-password") {
              setSnackbarState({
                state: true,
                message: "User ID or Password is incorrect. 😟",
                status: "error",
              });
            } else if (error.code === "auth/user-disabled") {
              setSnackbarState({
                state: true,
                message: "Account has not been verified. 😟",
                status: "error",
              });
            } else {
              setSnackbarState({
                state: true,
                message: "Something went wrong. 😟",
                status: "error",
              });
            }
          }
          //*/
        },
        [history]
      )}
    >
      {(formik) => (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
          noValidate
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                id="userID"
                name="userID"
                placeholder="Mobile Number / Email ID"
                margin="dense"
                variant="outlined"
                className={classes.input}
                {...formik.getFieldProps("userID")}
                error={formik.errors.userID && formik.touched.userID}
                helperText={
                  formik.errors.userID && formik.touched.userID
                    ? formik.errors.userID
                    : "Mobile Number / Email ID"
                }
                disabled={formik.isSubmitting}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                id="password"
                name="password"
                placeholder="Password"
                margin="dense"
                variant="outlined"
                type="password"
                className={classes.input}
                {...formik.getFieldProps("password")}
                error={formik.errors.password && formik.touched.password}
                helperText={
                  formik.errors.password && formik.touched.password
                    ? formik.errors.password
                    : "Password"
                }
                disabled={formik.isSubmitting}
                fullWidth
              />
            </Grid>
            <Grid item xs={5}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="loginCheckbox"
                    name="loginCheckbox"
                    type="checkbox"
                    checked={formik.values.loginCheckbox}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={formik.isSubmitting}
                    color="secondary"
                  />
                }
                label="Remember me"
              />
            </Grid>
            <Grid item xs={2} />
            <Grid item xs={5}>
              <Link
                href="#"
                color="primary"
                onClick={(e) => {
                  e.preventDefault();
                  history.push("/forgot_password");
                }}
              >
                <Box textAlign="right" lineHeight={2.5}>
                  Forgot Password?
                </Box>
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Button
                color="primary"
                variant="contained"
                className={classes.buttonLogin}
                disabled={formik.isSubmitting}
                fullWidth
                type="submit"
              >
                Login
              </Button>
            </Grid>
            {/*<Grid item xs={12}>
          <Divider variant="middle" />
        </Grid>
        <Grid item xs={12}>
          <Button
            color="secondary"
            variant="contained"
            startIcon={<Facebook />}
            className={classes.buttonFacebook}
            fullWidth
          >
            Connect with Facebook
          </Button>
          </Grid>*/}
          </Grid>
        </form>
      )}
    </Formik>
  );
};

export default LoginForm;
